import React, { useState } from 'react'
import ProductFeedbacks from './ProductFeedbacks'
import { useParams } from 'react-router-dom'
import { useProductReflectionFeedbacksQuery } from '@graphql/queries/__generated__/product-details.generated'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { DialogContent, Divider } from '@mui/material'
import FeedbackDetails from '@components/Feedback/FeedbackDetails'
import ProductFeedbacksPaginator from './ProductFeedbacksPaginator'
import { Ordering } from '../../../../../generated/gqlTypes'

const PAGINATE_BY = 10

const ProductFeedbacksView: React.FC<{
  initialId?: number | string
}> = ({ initialId }) => {
  const { id } = useParams<any>()
  const [page, setPage] = useState(1)
  const [isShowAll, setIsShowAll] = useState(false)
  const dataFeedbacksQuery = useProductReflectionFeedbacksQuery({
    variables: {
      id: String(initialId || id),
      limit: PAGINATE_BY,
      offset: (page - 1) * PAGINATE_BY,
      sortBy: [{ score: Ordering.Desc }, { timeCreated: Ordering.Desc }],
    },
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })
  const feedbackData =
    dataFeedbacksQuery.data?.specific?.product?.feedbacks ||
    dataFeedbacksQuery.previousData?.specific?.product?.feedbacks

  if (!feedbackData || !feedbackData?.totalCount) {
    return null
  }

  return (
    <>
      <div className='my-10'>
        <Divider />
      </div>
      <ProductFeedbacks dataFeedbacks={feedbackData} loading={dataFeedbacksQuery.loading} setIsShowAll={setIsShowAll} />
      <Dialog open={isShowAll} onClose={() => setIsShowAll(false)} fullWidth>
        <DialogTitle>
          <span className='font-semibold text-capitalize'>Reviews</span>
          <span className='absolute right-10 top-10'>
            <IconButton onClick={() => setIsShowAll(false)} size='medium' title='Close'>
              <CloseIcon fontSize='large' />
            </IconButton>
          </span>
        </DialogTitle>
        <DialogContent className='w-600 max-w-full' dividers>
          {feedbackData.results.map(node => (
            <FeedbackDetails key={node.pk} feedback={node} />
          ))}
          <ProductFeedbacksPaginator
            page={page}
            numPages={Math.ceil(feedbackData.totalCount / PAGINATE_BY)}
            setPage={setPage}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ProductFeedbacksView
